/**
 * SEO slug helpers for entities and public rate URLs.
 */

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
}

export function entityPath(entity: { slug: string }): string {
  return `/rate/${entity.slug}`
}

export function sharePathForEntity(entity: { slug: string }): string {
  return `ratewdw.com/rate/${entity.slug}`
}

/** cuid-ish ids from Prisma (no hyphens in default cuid, but accept common id forms). */
export function looksLikeEntityId(value: string): boolean {
  if (!value) return false
  // Prisma cuid: starts with 'c', ~25 chars alphanumeric
  if (/^c[a-z0-9]{20,32}$/i.test(value)) return true
  // uuid
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)) {
    return true
  }
  return false
}

/**
 * Build a unique slug candidate list: base, base-parent, base-2, …
 */
export function buildSlugCandidates(
  name: string,
  parentName?: string | null,
  idSuffix?: string
): string[] {
  const base = slugify(name) || 'entity'
  const candidates = [base]
  if (parentName) {
    const withParent = slugify(`${name}-${parentName}`)
    if (withParent && withParent !== base) candidates.push(withParent)
  }
  for (let i = 2; i <= 20; i++) {
    candidates.push(`${base}-${i}`)
  }
  if (idSuffix) {
    candidates.push(`${base}-${idSuffix.slice(0, 8).toLowerCase()}`)
  }
  return candidates
}
